module.exports = __webpack_public_path__ + "static/media/slider-3.ef64689f.jpg";